import { Navigate } from "react-router-dom";

export default function ErrorPage() {
  //  const error = useRouteError();
  return <Navigate to="/" />;
}
